import React from 'react';
import { IStepLabel, Step } from './HelpAndFAQArticle';
import { useNavigate } from 'react-router-dom';





interface IHelpAndFAQArticleStepsProps {
    steps: Step[];
    level: string;
}



const HelpAndFAQArticleSteps: React.FC<IHelpAndFAQArticleStepsProps> = (props) => {

    const {steps,level} = props
    const navigate = useNavigate();


    const containerClassMap = {
        'primary' : 'help__and__faq__article__steps__container-primary-step',
        'secondary': 'help__and__faq__article__steps__container-secondary-step',
        'tertiary': 'help__and__faq__article__steps__container-tertiary-step'
    }

    const containerClassName = containerClassMap[level];


    const getCorrespondingBullet = (num:number,level:string,lower?:boolean):string | number | null => {
        /*
            Give alphabet corresponding to the number

            Args:
                num: number between 0 to 25
                level: level of step (primary, secondary, tertiary)
                lower: boolean to get lowercase or uppercase
        */
       if(level === 'primary') return num;
       else if (level === 'secondary') return lower ? String.fromCharCode(96 + num) : String.fromCharCode(64 + num)
       else return null;
    }

    const handleLinkClick = (labelItem: IStepLabel): void => {
        /*
            It handles the navigation link clicked within the steps.

            Args:
                labelItem: label object of step of type IStepLabel
        */

        if(labelItem.type !== 'link' || !labelItem?.path)return;
        else {
            navigate(labelItem?.path)
        }
    }

    return (
        <>
        {
            steps?.map((step:Step,index:number)=>{
                return (
                    <div 
                    key={containerClassName+'-'+index}
                    className={containerClassName}>
                        <div className={containerClassName + '-label'}>
                            <div className={containerClassName + '-label-index'}>{getCorrespondingBullet(index+1,level)}</div>
                            <div className={containerClassName + '-label-content'}>
                                {
                                step?.label && step?.label?.length > 0 && step?.label?.map((labelItem,idx)=>{
                                    return (
                                        <span 
                                        className={containerClassName +  (labelItem?.type==='link' ? '-label-link'  : labelItem?.type==='text-bold'? '-label-bold' : '-label-normal')}
                                        key={containerClassName + '-'+index+'-label-part'+idx}
                                        onClick={()=>{
                                            handleLinkClick(labelItem);
                                        }}
                                        >{labelItem?.content}</span>
                                    )
                                })
                            }
                            </div>
                        </div>
                        {
                            step?.image && <div className={containerClassName + '-image-container'}>
                                <img src={step?.image} alt="" className={containerClassName + '-image'} />
                            </div>
                        }
                        {
                            step?.children && step?.children?.length > 0 && <div className='help__and__faq__article__step__children__container'>
                                <HelpAndFAQArticleSteps steps={step?.children} level={level === 'primary'? 'secondary' : 'tertiary'}/>
                            </div>
        
                        }
                    </div>
                )
            })
        }
        </>
    )
}



export default HelpAndFAQArticleSteps;